<template>
  <div>
    <LayoutOne v-if="layoutType === 'layout_one'" :binding-type="bindingType" />
  </div>
</template>

<script>
  import LayoutOne from "./LayoutOne/LayoutOne.vue"

  export default {
    name: "LayoutSelector",
    components: {
      LayoutOne,
    },
    props: {
      layoutType: {
        type: String,
        default: "",
        required: true,
      },
      bindingType: {
        type: String,
        default: "",
      },
    },
  }
</script>
